import is from '@sindresorhus/is';
import { matchPath } from 'react-router';
import { z } from 'zod';

import { serializeUrlTilePayloads, URL_TILE_SEARCH_PARAM, type UrlTileLegacyRewriter } from '../url-tiles';
import { createPositionTilePayload } from './position-tile-payload';
import { positionManagementRoute } from './route';
import { ARCHITECTURE_ID_SEARCH_PARAM } from './search-param';

const LEGACY_ARCHITECTURE_ID_SEARCH_PARAM = 'positionArchitectureId';
const LEGACY_POSITION_SEARCH_PARAM = 'position';

const uuidOrUndefined = (value: string | null): string | undefined => {
    const parsed = z.uuid().safeParse(value);

    return parsed.success ? parsed.data : undefined;
};

export const positionManagementLegacyUrlTileRewriter: UrlTileLegacyRewriter = {
    rewrite: ({ definitions, hadCanonicalTileParams, location, searchParams }) => {
        const isPositionManagementPage = !is.null(
            matchPath(positionManagementRoute.patterns.positionManagement, location.pathname),
        );
        const hasLegacyParams =
            searchParams.has(LEGACY_ARCHITECTURE_ID_SEARCH_PARAM) || searchParams.has(LEGACY_POSITION_SEARCH_PARAM);

        if (!isPositionManagementPage || !hasLegacyParams) return undefined;

        const architectureId = uuidOrUndefined(searchParams.get(LEGACY_ARCHITECTURE_ID_SEARCH_PARAM));
        const positionId = uuidOrUndefined(searchParams.get(LEGACY_POSITION_SEARCH_PARAM));
        const nextParams = new URLSearchParams(searchParams);

        nextParams.delete(LEGACY_ARCHITECTURE_ID_SEARCH_PARAM);
        nextParams.delete(LEGACY_POSITION_SEARCH_PARAM);

        if (architectureId !== undefined && !nextParams.has(ARCHITECTURE_ID_SEARCH_PARAM)) {
            nextParams.set(ARCHITECTURE_ID_SEARCH_PARAM, architectureId);
        }
        if (positionId !== undefined && !hadCanonicalTileParams) {
            for (const value of serializeUrlTilePayloads([createPositionTilePayload({ positionId })], definitions)) {
                nextParams.append(URL_TILE_SEARCH_PARAM, value);
            }
        }

        return nextParams;
    },
};
